import i18n from "@/i18n";
import { copyToClipboard, toasts } from "@skailer-com/uikit";

export async function copyTextWithNotify(text: string): Promise<boolean> {
  const copied = await copyToClipboard(text);
  if (!copied) {
    toasts.showError({ title: i18n.t("common:copy_failed") });
  }
  return copied;
}
